import _ from "lodash"
import { partyAddApi } from "../../api/party/partyAddApi"

type PayloadShape = Parameters<typeof partyAddApi>[0]

export async function partyAddService(payload: PayloadShape, token: string) {
	if (_.isEmpty(payload.note)) payload.note = undefined
	return await partyAddApi(payload, token)
}
